const DEFAULT_API_ORIGIN = "http://192.168.29.104:9000";

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, "");

export const API_ORIGIN = trimTrailingSlashes(
  process.env.REACT_APP_API_URL?.trim() || DEFAULT_API_ORIGIN,
);

export const buildApiUrl = (path: string) =>
  `${API_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
